import { Chakra } from "@airhelp/react-ui-components";
import PostListItem from "modules/common/components/PostListItem";
import type { RelatedArticlesProps, RelatedArticlesMapProps } from "../RelatedArticles.d";

const { SimpleGrid } = Chakra;

const PostListItemsDesktop = ({ relatedArticles, fallbackFeaturedImage }: RelatedArticlesProps) =>
    <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8}>
      {relatedArticles.map((story: RelatedArticlesMapProps["story"]) => (
        <PostListItem key={story.id} story={story} fallbackFeaturedImage={fallbackFeaturedImage} />
      ))}
    </SimpleGrid>

export default PostListItemsDesktop;
